import { TYPES } from '../flattenTree/utils/consts';
import { getName, isNode } from './helpers';

export const toUrlFormat = (nodeName = '') => {
  return nodeName.trim().replace(/\s+/g, '-').toLowerCase();
};

const addUrlFormatToNodeProperties = (node) => {
  const addUrlFormatTo = [
    'operations',
    'clientEvents',
    'messages',
    'callbacks',
    'properties',
    'relatedGuides',
    'events',
  ];

  addUrlFormatTo.forEach((key) => {
    if (node[key]) {
      node[key] = node[key].map((prop) => ({
        ...prop,
        urlFormat: prop.urlFormat || toUrlFormat(getName(prop)),
      }));
    }
  });
};

const addOriginalPathToNodeProperties = (nodeData, prefix) => {
  const addPathTo = [
    'operations',
    'clientEvents',
    'messages',
    'callbacks',
    'properties',
    'relatedGuides',
    'events',
  ];

  addPathTo.forEach((key) => {
    if (nodeData[key]) {
      nodeData[key] = nodeData[key].map((prop) => ({
        ...prop,
        originalPath: prefix
          ? `${prefix}.${prop.urlFormat}`
          : prop.urlFormat || toUrlFormat(getName(prop)),
      }));
    }
  });
};

const addLinkToNodeProperties = (nodeData, prefixUrl) => {
  const addPathTo = [
    'operations',
    'clientEvents',
    'messages',
    'callbacks',
    'properties',
    'relatedGuides',
    'events',
  ];

  addPathTo.forEach((key) => {
    if (nodeData[key]) {
      nodeData[key] = nodeData[key].map((prop) => ({
        ...prop,
        link: prefixUrl
          ? `${prefixUrl}/${prop.urlFormat}`
          : prop.urlFormat || toUrlFormat(getName(prop)),

        parentRef: prefixUrl || '',
      }));
    }
  });
};

export const addUrlFormatVisitor = (node, key) => {
  /*
    1. set urlFormat on node.
    2. set urlFormat on node properties (operations, messages, events, etc...)
  */
  if (isNode(node)) {
    node.data.urlFormat =
      node.data.urlFormat ||
      toUrlFormat(key ? key.replace('/', '') : node.data.name);

    addUrlFormatToNodeProperties(node.data);
  }
};

export const addOriginalPathVisitor = (node, key, additionalArgs = {}) => {
  /*
    we add originalPath to the node and his properties
    for the search, in order to later on generate unique id for documents.
  */
  const { pathPrefix } = additionalArgs;
  if (isNode(node)) {
    node.data.originalPath = pathPrefix
      ? `${pathPrefix}.${node.data.urlFormat}`
      : node.data.urlFormat;
    addOriginalPathToNodeProperties(node.data, node.data.originalPath);
    return { pathPrefix: node.data.originalPath };
  }
};

export const addLinksAndParentRefVisitor = (node, key, additionalArgs = {}) => {
  const { urlPrefix } = additionalArgs;
  if (isNode(node)) {
    node.data.link = urlPrefix
      ? `${urlPrefix}/${node.data.urlFormat}`
      : `/${node.data.urlFormat}`;

    node.data.parentRef = urlPrefix || '';

    addLinkToNodeProperties(node.data, node.data.link);
    return { urlPrefix: node.data.link };
  }
};

export const addTypesVisitor = (node) => {
  if (isNode(node)) {
    node.data.propType =
      node.data.propType ||
      (node.data.parentRef ? TYPES.SECTION : TYPES.CATEGORY);

    const addTypeTo = [
      { key: 'operations', propType: TYPES.OPERATION },
      { key: 'clientEvents', propType: TYPES.CLIENT_EVENT },
      { key: 'messages', propType: TYPES.MAIN_ENTITY },
      { key: 'properties', propType: TYPES.PROPERTY },
      { key: 'relatedGuides', propType: TYPES.MD },
      { key: 'events', propType: TYPES.WEBHOOK },
    ];

    addTypeTo.forEach(({ key, propType }) => {
      if (node.data[key]) {
        node.data[key] = node.data[key].map((prop) => ({
          ...prop,
          propType, // we can't use type since we already have type field on the events.
        }));
      }
    });
  }
};

export const updateEventsStructure = (node) => {
  /*
    copy description field from the event.desceiption to event.docs.description
    for consistency
  */
  if (isNode(node)) {
    if (node.data.events) {
      node.data.events = node.data.events.map((event) => ({
        ...event,
        docs: event.docs
          ? { ...event.docs, description: event.description }
          : { description: event.description },
      }));
    }
  }
};

export { markMainEntitiesVisitor } from './markMainEntitiesVisitor';
export { createTagsSubTreesVisitor } from './createTagsSubTreesVisitor';
export { nodeMixingEnricher } from './nodeMixingEnricher';
export { markCallbacksVisitor } from './markCallbacksVisitor';
export { createGuideFromIndexPageDescriptionVisitor } from './createGuideFromIndexPageDescriptionVisitor';
export { addGuidesToNodesVisitor } from './createGuideTags';
export { avoidNameCollisionsVisitor } from './avoidNameCollisionsVisitor';
export { deleteEmptyCategories } from './deleteEmptyCategories';
export { addArtifactIdVisitor } from './addArtifactIdVisitor';
export { changeSubTreeKeyVisitor } from './changeSubTreesKey';
export { nodeMixingEnricherVisitor } from './nodeMixingEnricherVisitor';
export { removeFlyntCommentsVisitor } from './removeFlyntCommentsVisitor';
